import React, { useEffect, useState } from "react"
import { FETCH_KEYS, readCookie } from "../../api"
import axios from "axios"
import { BaseModal } from "../BaseModal"
import { Box, Center, Loader, ScrollArea, Table, Text } from "@mantine/core"

type DetailColumn = {
  field: string
  header_name: string
  cell_data_type: string
  value: string | number | null
}

interface Props {
  opened: boolean
  clientId: number
  simpleUserId: number | null
  userName: string
  snapshotDate: string
  onClose: () => void
}

const UserDetailModal: React.FC<Props> = ({
  opened,
  clientId,
  simpleUserId,
  userName,
  snapshotDate,
  onClose,
}) => {
  const [columns, setColumns] = useState<DetailColumn[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // 常時マウントのため、開いていない間・レコード未選択の間は取得しない
    if (!opened || simpleUserId === null) return
    let ignore = false

    const fetchDetail = async () => {
      setLoading(true)
      setError(null)

      try {
        const url = FETCH_KEYS.fetchCrmScoringUserDetail(clientId, simpleUserId, snapshotDate)
        const res = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${readCookie('access_token')}`,
          },
        })
        if (!ignore) setColumns(res.data.columns)
      } catch (e: any) {
        if (!ignore) setError(e?.response?.status === 404 ? 'データが見つかりません' : '読み込みに失敗しました')
      } finally {
        if (!ignore) setLoading(false)
      }
    }
    fetchDetail()
    return () => { ignore = true }
  }, [opened, clientId, simpleUserId, snapshotDate])

  // 閉じ切ってから初期化し、次に開いたときに前回の結果が一瞬見えるのを防ぐ
  const handleExited = () => {
    setColumns(null)
    setError(null)
    setLoading(true)
  }

  return (
    <BaseModal
      opened={opened}
      onClose={onClose}
      title="紹介者詳細"
      width={600}
      onExited={handleExited}
    >
      <Box px={24} py={16}>
        <Text fw={600}>{userName || '-'}</Text>
        <Text fz={11} c="#00000099">ID: {simpleUserId ?? '-'}</Text>
      </Box>

      <ScrollArea style={{ flex: 1, minHeight: 0 }} px={24} pb={24}>
        {loading ? (
          <Center mih={200}>
            <Loader />
          </Center>
        ) : error ? (
          <Text fz={13} c="red">{error}</Text>
        ) : !columns || columns.length === 0 ? (
          <Text fz={13} c="#00000099">該当データなし</Text>
        ) : (
          <Table withTableBorder>
            <Table.Tbody>
              {columns.map((col) => (
                <Table.Tr key={col.field}>
                  <Table.Th bg="#00000008" w="40%">{col.header_name}</Table.Th>
                  <Table.Td>
                    {col.value === null || col.value === undefined || col.value === '' ? (
                      <Text span c="#00000099">-</Text>
                    ) : (
                      String(col.value)
                    )}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        )}
      </ScrollArea>
    </BaseModal>
  )
}

export default UserDetailModal
